export default {
  name: 'PaymentInfo',
  created() {
    document.getElementById('html').classList.add('hide');
  },
  methods: {}
};
